<form name="form">
    <div class="form-group">
        <div class="form-group-inner">
            <label for="name">First name</label
            ><input
                legacy-css
                type="text"
                id="my-profile-firstname"
                name="firstname"
                readonly
                placeholder=""
                [(ngModel)]="user.FirstName" />
        </div>
    </div>
    <div class="form-group">
        <div class="form-group-inner">
            <label for="name">Surname</label
            ><input legacy-css type="text" id="my-profile-surname" name="surname" readonly [(ngModel)]="user.Surname" />
        </div>
    </div>
    <div class="form-group">
        <div class="form-group-inner">
            <label for="name">Email</label
            ><input legacy-css type="email" id="my-profile-email" name="email" readonly [(ngModel)]="user.Email" />
        </div>
    </div>
    <div class="form-group form-group--spaced">
        <div class="form-group-inner">
            <label for="name">Role</label><span>{{ user.AppRole }}</span>
        </div>
    </div>
    <div class="form-group form-group--spaced form-group--hoverable">
        <div class="form-group-inner">
            <label for="name">2-Step Verification</label>
            <ui-switch
                size="small"
                [beforeChange]="preToggleMfaCheck"
                [checked]="mfaEnabled"
                (change)="toggleMfa($event)"
                [disabled]="mfaForced && mfaEnabled"></ui-switch>
        </div>
    </div>
    <div class="form-group form-group--spaced form-group--hoverable" *ngIf="!isSmallViewport">
        <div class="form-group-inner">
            <label for="name">Show Help Icon</label>
            <ui-switch id="show-help-icon" size="small" [checked]="showIntercomLauncher" (change)="toggleIntercomLauncher()"></ui-switch>
        </div>
    </div>
    <div class="form-group form-group--spaced form-group--hoverable">
        <div class="form-group-inner">
            <label for="name">Show Quick Start</label>
            <ui-switch id="quick-start-switch-button" size="small" [checked]="showQuickStart" (change)="toggleQuickStart()"></ui-switch>
        </div>
    </div>
    <div class="form-group form-group--spaced form-group--hoverable">
        <div class="form-group-inner">
            <label for="name">Social Account Login</label>
            <ui-switch
                id="social-account-login-switch-button"
                size="small"
                [checked]="user.EnableSocialAccountLogin"
                (change)="toggleSocialAccountLogin()"></ui-switch>
        </div>
    </div>

    <div class="form-group form-group--spaced form-group--hoverable">
        <div class="form-group-inner">
            <label for="name">Password</label>
            <div class="new">
                <button type="button" class="btn-bx-secondary" (click)="confirmResetPassword()">
                    {{ this.user.UserHasSetupPassword === true ? 'Reset Password' : 'Set Password' }}
                </button>
            </div>
        </div>
        @if (showRemovePassword && this.user.UserHasSetupPassword) {
            <div class="form-group-inner">
                <label></label>
                <div class="new">
                    <button type="button" id="remove-password" class="btn-bx-secondary" (click)="confirmRemovePassword()">
                        Remove Password
                    </button>
                </div>
            </div>
        }
    </div>
</form>
